webpackJsonp([9],{

/***/ 370:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b879125",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    token: {
      type: String
    },
    generalFeedback: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      thanksMessage: 'Obrigado pela sua opinião!',
      secondFieldLabel: 'Comente:',
      sendBtnText: 'Enviar',
      formTextarea: '',
      showFeedbackForm: false,
      satisfaction: 0,
      dataSent: false
    };
  },

  computed: {
    btnText: function btnText() {
      return this.generalFeedback ? 'Feedback' : 'Dê sua opinião';
    },
    firstFieldLabel: function firstFieldLabel() {
      return this.generalFeedback ? 'Nos conte sobre sua experiência.' : 'Achou o valor atrativo?';
    }
  },
  methods: {
    openFeedbackForm: function openFeedbackForm() {
      this.showFeedbackForm = true;
    },
    closeFeedbackForm: function closeFeedbackForm() {
      this.showFeedbackForm = false;
    },
    sendFormData: function sendFormData() {
      var _this = this;

      this.$store.commit('updateSatisfaction', this.satisfaction === 0);
      this.$store.commit('updateObservation', this.formTextarea);

      this.$store.dispatch('sendHotsiteFeedback', this.token).then(function (_ref) {
        var data = _ref.data;

        _this.dataSent = true;

        setTimeout(function () {
          _this.closeFeedbackForm();
        }, 2000);
      }).catch(function (err) {
        return console.log(err);
      });
    }
  }
});

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".feedback-main-container[data-v-6d7af7e4]{padding-top:0;padding-bottom:0}.feedback-close-btn[data-v-6d7af7e4]{cursor:pointer}.feedback-form[data-v-6d7af7e4]{cursor:auto;width:25em;max-width:320px;margin:0 auto;background:#fff;position:absolute;bottom:0;right:0;padding:1em}.feedback-textarea[data-v-6d7af7e4]{width:100%;max-width:100%;border:1px solid #ccc;padding:.5em}.feedback-form .subheader[data-v-6d7af7e4]{padding:0}.feedback-form-body[data-v-6d7af7e4]{position:relative}.feedback-form-footer[data-v-6d7af7e4]{padding:.5em 0}.thanks-overlay[data-v-6d7af7e4]{background:#fff;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;position:absolute;bottom:0;top:0;right:0;left:0}.box-title-feedback[data-v-6d7af7e4]{margin-top:6px;color:#6d7884;font-size:18px}@media (max-width:720px){.feedback-main-container[data-v-6d7af7e4]{max-width:320px;margin:0 auto;overflow:hidden;padding:0}.feedback-form[data-v-6d7af7e4]{left:48%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.feedback-open-btn[data-v-6d7af7e4]{float:right}}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/Feedback.vue"],"names":[],"mappings":"AACA,0CACE,cAAe,AACf,gBAAkB,CACnB,AACD,qCACE,cAAgB,CACjB,AACD,gCACE,YAAa,AACb,WAAY,AACZ,gBAAiB,AACjB,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,SAAU,AACV,QAAS,AACT,WAAa,CACd,AACD,oCACE,WAAY,AACZ,eAAgB,AAChB,sBAAuB,AACvB,YAAc,CACf,AACD,2CACE,SAAW,CACZ,AACD,qCACE,iBAAmB,CACpB,AACD,uCACE,cAAgB,CACjB,AACD,iCACE,gBAAiB,AACjB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAmB,AACnB,SAAU,AACV,MAAO,AACP,QAAS,AACT,MAAQ,CACT,AACD,qCACE,eAAgB,AAChB,cAAe,AACf,cAAgB,CACjB,AACD,yBACA,0CACI,gBAAiB,AACjB,cAAe,AACf,gBAAiB,AACjB,SAAW,CACd,AACD,gCACI,SAAU,AACV,mCAAoC,AAC5B,0BAA4B,CACvC,AACD,oCACI,WAAa,CAChB,CACA","file":"Feedback.vue","sourcesContent":["\n.feedback-main-container[data-v-6d7af7e4] {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.feedback-close-btn[data-v-6d7af7e4] {\n  cursor: pointer;\n}\n.feedback-form[data-v-6d7af7e4] {\n  cursor: auto;\n  width: 25em;\n  max-width: 320px;\n  margin: 0 auto;\n  background: #fff;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  padding: 1em;\n}\n.feedback-textarea[data-v-6d7af7e4] {\n  width: 100%;\n  max-width: 100%;\n  border: 1px solid #ccc;\n  padding: .5em;\n}\n.feedback-form .subheader[data-v-6d7af7e4] {\n  padding: 0;\n}\n.feedback-form-body[data-v-6d7af7e4] {\n  position: relative;\n}\n.feedback-form-footer[data-v-6d7af7e4] {\n  padding: .5em 0;\n}\n.thanks-overlay[data-v-6d7af7e4] {\n  background: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: absolute;\n  bottom: 0;\n  top: 0;\n  right: 0;\n  left: 0;\n}\n.box-title-feedback[data-v-6d7af7e4]{\n  margin-top: 6px;\n  color: #6d7884;\n  font-size: 18px;\n}\n@media all and (max-width: 720px) {\n.feedback-main-container[data-v-6d7af7e4] {\n    max-width: 320px;\n    margin: 0 auto;\n    overflow: hidden;\n    padding: 0;\n}\n.feedback-form[data-v-6d7af7e4] {\n    left: 48%;\n    -webkit-transform: translateX(-50%);\n            transform: translateX(-50%);\n}\n.feedback-open-btn[data-v-6d7af7e4] {\n    float: right;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(471);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("db6e981a", content, true, {});

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(485)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(511),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6d7af7e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 511:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "feedback-main-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "red feedback-open-btn white--text"
    },
    on: {
      "click": _vm.openFeedbackForm
    }
  }, [_vm._v("\n      " + _vm._s(_vm.btnText) + "\n      "), _c('v-icon', {
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("sentiment_satisfied_alt")])], 1), _vm._v(" "), _c('v-slide-y-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.showFeedbackForm) ? _c('div', {
    staticClass: "feedback-form elevation-6"
  }, [_c('div', {
    staticClass: "feedback-form-main"
  }, [_c('v-layout', {
    staticClass: "form-header"
  }, [_c('v-flex', {
    staticClass: "box-title-feedback"
  }, [_c('strong', [_vm._v(_vm._s(_vm.btnText))])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeFeedbackForm
    }
  }, [_c('v-icon', {
    staticClass: "feedback-close-btn"
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticClass: "progress-line ma-0",
    attrs: {
      "height": "2",
      "color": "red",
      "indeterminate": false,
      "background-color": "white"
    }
  }), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-0"
  }), _vm._v(" "), _c('div', {
    staticClass: "feedback-form-body"
  }, [_c('div', [_c('v-subheader', [_vm._v(_vm._s(_vm.firstFieldLabel))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "d-flex": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "sm4": "",
      "md4": "",
      "offset-xs4": "",
      "offset-sd4": "",
      "offset-md4": ""
    }
  }, [_c('v-btn-toggle', {
    attrs: {
      "mandatory": ""
    },
    model: {
      value: (_vm.satisfaction),
      callback: function($$v) {
        _vm.satisfaction = $$v
      },
      expression: "satisfaction"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    class: {
      'green--text': _vm.satisfaction === 0
    }
  }, [_vm._v("thumb_up_alt")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    class: {
      'red--text': _vm.satisfaction === 1
    }
  }, [_vm._v("thumb_down_alt")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.secondFieldLabel))])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formTextarea),
      expression: "formTextarea"
    }],
    staticClass: "feedback-textarea",
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.formTextarea)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formTextarea = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "feedback-form-footer"
  }, [_c('v-flex', {
    attrs: {
      "align-end": "",
      "d-flex": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.sendFormData
    }
  }, [_vm._v("Enviar")])], 1)], 1), _vm._v(" "), _c('v-slide-y-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.dataSent) ? _c('div', {
    staticClass: "thanks-overlay"
  }, [_vm._v(_vm._s(_vm.thanksMessage))]) : _vm._e()])], 1)], 1)]) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CondicoesDeUso__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CondicoesDeUso___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CondicoesDeUso__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Feedback__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Feedback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Feedback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'checkOut',
  props: ['token'],
  components: {
    CondicoesDeUso: __WEBPACK_IMPORTED_MODULE_0__CondicoesDeUso___default.a,
    Feedback: __WEBPACK_IMPORTED_MODULE_1__Feedback___default.a
  },
  data: function data() {
    return {
      dialog: false,
      showFeedbackBtn: true,
      aware: false
    };
  },

  computed: {
    paymentsViewModel: function paymentsViewModel() {
      var _this = this;

      var payment = this.item.paymentsViewModel.filter(function (elem) {
        if (elem.idItem.indexOf(_this.$store.getters.itemChoosen.id) !== -1) {
          return elem;
        }
      });
      if (payment.length === 0) {
        this.$store.commit('updatePaymentChoosen', null);
      }
      return payment;
    },

    acceptance: {
      get: function get() {
        return this.$store.getters.acceptance;
      },
      set: function set(value) {
        this.$store.commit('updateAcceptance', value);
      }
    },
    dateChoosen: {
      get: function get() {
        return this.$store.getters.dateChoosen;
      },
      set: function set(value) {
        this.$store.dispatch('choseDate', value);
      }
    },
    timeChoosen: {
      get: function get() {
        return this.$store.getters.timeChoosen;
      },
      set: function set(value) {
        this.$store.commit('updateTimeChoosen', value);
      }
    },
    unityChoosen: {
      get: function get() {
        return this.$store.getters.unityChoosen;
      },
      set: function set(value) {
        this.$store.commit('updateUnityChoosen', value);
      }
    },
    paymentChoosen: {
      get: function get() {
        return this.$store.getters.paymentChoosen;
      },
      set: function set(value) {
        this.$store.commit('updatePaymentChoosen', value);
      }
    },
    itemChoosen: {
      get: function get() {
        return this.$store.getters.itemChoosen;
      },
      set: function set(value) {
        this.$store.commit('updateItemChoosen', value);
      }
    },
    avaliableSchedule: function avaliableSchedule() {
      return this.$store.getters.avaliableSchedule;
    },
    client: function client() {
      return this.$store.getters.client;
    },
    unity: function unity() {
      return this.$store.getters.unity;
    },
    item: function item() {
      return this.$store.getters.item;
    },
    priceRef: function priceRef() {
      return this.$store.getters.itemChoosenPriceRef;
    },
    itemDescription: function itemDescription() {
      return this.$store.getters.itemChoosenDescription;
    },
    price: function price() {
      return this.$store.getters.itemChoosenPrice;
    },
    selectPriceVariation: function selectPriceVariation() {
      return this.$store.getters.priceVariation;
    },
    itemActive: function itemActive() {
      if (this.item === null) return;
      var time = this.item.dates[0];
      time = time.split('T')[0];
      time = time + 'T' + this.avaliableSchedule[this.avaliableSchedule.length - 1];
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(time).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()()) > 0;
    },
    loadingCheckout: function loadingCheckout() {
      return this.$store.getters.loadingCheckout;
    },
    loadingOrderRequest: function loadingOrderRequest() {
      return this.$store.getters.loadingOrderRequest;
    }
  },
  methods: {
    openDialog: function openDialog() {
      if (this.acceptance) {
        this.dialog = true;
      } else {
        this.$store.commit('toastr', {
          color: 'info',
          texto: 'Aceite as condições do uso'
        });
      }
    },
    requestOrder: function requestOrder() {
      this.$store.dispatch('requestOrder', this.token);
    },
    notAvaliable: function notAvaliable(value) {
      return this.notAvaliableSchedules.indexOf(value) !== -1;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('getCupom', this.token);
    this.$store.dispatch('getAllInfo', this.token);
  },

  filters: {
    time: function time(value) {
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()('2013-01-01T' + value).format('HH:mm');
    },
    formatDate: function formatDate(value) {
      return !value ? '' : __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('DD/MM/YYYY');
    },
    currency: function currency(value) {
      var newValue = 0;
      if (typeof value !== 'number') {
        newValue = parseFloat(value.replace('.', '').replace(',', '.'));
      } else if (typeof value === 'number') {
        newValue = value;
      } else {
        return '';
      }
      return newValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'condicoes-de-uso',
  data: function data() {
    return {
      condicoesDeUso: false
    };
  }
});

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".box-want[data-v-2b879125]{background:#fff;width:320px;margin:auto;padding:20px;margin-top:20px;margin-bottom:30px;border-radius:20px;color:#49515c;font-size:16px}.time-item[data-v-2b879125]{font-size:18px;color:#49515c;text-transform:capitalize}.notAvaliable[data-v-2b879125]{text-decoration:line-through;color:#afafaf}.item-name[data-v-2b879125]{color:#f59620;font-size:20px;text-align:left;margin-top:12px}.realization-date[data-v-2b879125]{padding:10px;font-size:20px}.description[data-v-2b879125],.more-description[data-v-2b879125]{margin-top:10px;margin-bottom:10px}.price[data-v-2b879125]{margin-bottom:15px;padding:5px;border:1px solid #9a9a9a;text-align:center}.real-price[data-v-2b879125]{float:left;height:30px;width:100%}.real-price>div[data-v-2b879125]{position:relative;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;margin:auto}.real-price>div[data-v-2b879125]:after{content:\" \";display:block;position:absolute;top:15px;left:-5px;right:-5px;height:1px;border-bottom:1px dashed #c7c7c7;border-top:1px dashed #c7c7c7}.real-price[data-v-2b879125]{font-size:20px;position:relative;color:#c7c7c7}.discount-price[data-v-2b879125]{color:#f59620;font-size:26px}.alert--text[data-v-2b879125]{color:#f59620}.realization-date i[data-v-2b879125]{position:relative;top:-2px}.time[data-v-2b879125]{width:100%;display:block;text-align:center;color:#49515c}.date[data-v-2b879125]{width:100%;display:block;text-align:right;color:#49515c}.feedback-btn[data-v-2b879125]{position:fixed;right:1em;bottom:1.5em}hr[data-v-2b879125]{margin-bottom:15px}@media (max-width:720px){.feedback-btn[data-v-2b879125]{position:relative;-webkit-transform:translateX(1.5em);transform:translateX(1.5em)}}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/Checkout.vue"],"names":[],"mappings":"AACA,2BACE,gBAAiB,AACjB,YAAa,AACb,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,cAAe,AACf,cAAgB,CACjB,AACD,4BACE,eAAgB,AAChB,cAAe,AACf,yBAA2B,CAC5B,AACD,+BACE,6BAA8B,AAC9B,aAAe,CAChB,AACD,4BACE,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,eAAiB,CAClB,AACD,mCACE,aAAc,AACd,cAAgB,CACjB,AACD,iEACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,wBACE,mBAAoB,AACpB,YAAa,AACb,yBAA0B,AAC1B,iBAAmB,CACpB,AACD,6BAEE,WAAY,AACZ,YAAa,AACb,UAAY,CACb,AACD,iCACE,kBAAmB,AACnB,0BAA2B,AAC3B,uBAAwB,AACxB,kBAAmB,AACnB,WAAa,CACd,AACD,uCACE,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,SAAU,AACV,UAAW,AACX,WAAY,AACZ,WAAY,AACZ,iCAAkC,AAClC,6BAA+B,CAChC,AACD,6BACE,eAAgB,AAChB,kBAAmB,AACnB,aAAe,CAChB,AACD,iCACE,cAAc,AACd,cAAgB,CACjB,AACD,8BACE,aAAc,CACf,AACD,qCACE,kBAAmB,AACnB,QAAU,CACX,AACD,uBACE,WAAY,AACZ,cAAe,AACf,kBAAmB,AACnB,aAAe,CAChB,AACD,uBACE,WAAY,AACZ,cAAe,AACf,iBAAkB,AAClB,aAAe,CAChB,AACD,+BACE,eAAgB,AAChB,UAAW,AACX,YAAc,CACf,AACD,oBACE,kBAAoB,CACrB,AACD,yBACA,+BACI,kBAAmB,AACnB,oCAAqC,AAC7B,2BAA6B,CACxC,CACA","file":"Checkout.vue","sourcesContent":["\n.box-want[data-v-2b879125]{\n  background: #fff;\n  width: 320px;\n  margin: auto;\n  padding: 20px;\n  margin-top: 20px;\n  margin-bottom: 30px;\n  border-radius: 20px;\n  color: #49515c;\n  font-size: 16px;\n}\n.time-item[data-v-2b879125]{\n  font-size: 18px;\n  color: #49515c;\n  text-transform: capitalize;\n}\n.notAvaliable[data-v-2b879125]{\n  text-decoration: line-through;\n  color: #afafaf;\n}\n.item-name[data-v-2b879125]{\n  color: #f59620;\n  font-size: 20px;\n  text-align: left;\n  margin-top: 12px;\n}\n.realization-date[data-v-2b879125]{\n  padding: 10px;\n  font-size: 20px;\n}\n.description[data-v-2b879125],.more-description[data-v-2b879125]{\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.price[data-v-2b879125]{\n  margin-bottom: 15px;\n  padding: 5px;\n  border: 1px solid #9a9a9a;\n  text-align: center;\n}\n.real-price[data-v-2b879125]{\n  position: relative;\n  float: left;\n  height: 30px;\n  width: 100%;\n}\n.real-price>div[data-v-2b879125]{\n  position: relative;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n  margin: auto;\n}\n.real-price>div[data-v-2b879125]::after{\n  content: ' ';\n  display: block;\n  position: absolute;\n  top: 15px;\n  left: -5px;\n  right: -5px;\n  height: 1px;\n  border-bottom: 1px dashed #c7c7c7;\n  border-top: 1px dashed #c7c7c7;\n}\n.real-price[data-v-2b879125]{\n  font-size: 20px;\n  position: relative;\n  color: #c7c7c7;\n}\n.discount-price[data-v-2b879125]{\n  color:#f59620;\n  font-size: 26px;\n}\n.alert--text[data-v-2b879125]{\n  color:#f59620;\n}\n.realization-date i[data-v-2b879125]{\n  position: relative;\n  top: -2px;\n}\n.time[data-v-2b879125]{\n  width: 100%;\n  display: block;\n  text-align: center;\n  color: #49515c;\n}\n.date[data-v-2b879125]{\n  width: 100%;\n  display: block;\n  text-align: right;\n  color: #49515c;\n}\n.feedback-btn[data-v-2b879125] {\n  position: fixed;\n  right: 1em;\n  bottom: 1.5em;\n}\nhr[data-v-2b879125] {\n  margin-bottom: 15px;\n}\n@media all and (max-width: 720px) {\n.feedback-btn[data-v-2b879125] {\n    position: relative;\n    -webkit-transform: translateX(1.5em);\n            transform: translateX(1.5em);\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 635:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(360)(true);
// imports


// module
exports.push([module.i, ".ql-container{-webkit-box-sizing:border-box;box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li:before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{-webkit-box-sizing:border-box;box-sizing:border-box;line-height:1.42;height:100%;outline:none;overflow-y:auto;padding:12px 15px;-o-tab-size:4;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li:before{content:\"\\2022\"}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li:before,.ql-editor ul[data-checked=true]>li:before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li:before{content:\"\\2611\"}.ql-editor ul[data-checked=false]>li:before{content:\"\\2610\"}.ql-editor li:before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl):before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl:before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) \". \"}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) \". \"}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) \". \"}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) \". \"}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) \". \"}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) \". \"}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) \". \"}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) \". \"}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) \". \"}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) \". \"}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank:before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.link{color:#1470c8;cursor:pointer;text-decoration:none}.modal-header{font-size:22px!important;font-weight:400;line-height:32px!important;letter-spacing:normal!important}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/hotsite/CondicoesDeUso.vue"],"names":[],"mappings":"AACA,cACE,8BAA+B,AACvB,sBAAuB,AAC/B,uCAA0C,AAC1C,eAAgB,AAChB,YAAa,AACb,SAAY,AACZ,iBAAmB,CACpB,AACD,sCACE,iBAAmB,CACpB,AACD,gEACE,mBAAqB,CACtB,AACD,cACE,eAAgB,AAChB,WAAY,AACZ,kBAAmB,AACnB,kBAAmB,AACnB,OAAS,CACV,AACD,gBACE,SAAU,AACV,SAAW,CACZ,AACD,WACE,8BAA+B,AACvB,sBAAuB,AAC/B,iBAAkB,AAClB,YAAa,AACb,aAAc,AACd,gBAAiB,AACjB,kBAAmB,AACnB,cAAe,AACZ,WAAY,AACf,gBAAiB,AACjB,gBAAiB,AACjB,qBAAsB,AACtB,oBAAsB,CACvB,AACD,aACE,WAAa,CACd,AACD,kKAWE,SAAU,AACV,UAAW,AACX,4EAA8E,CAC/E,AACD,4BAEE,kBAAoB,CACrB,AACD,kCAEE,oBAAsB,CACvB,AACD,wBACE,eAAiB,CAClB,AACD,mEAEE,mBAAqB,CACtB,AACD,6EAEE,kBAAoB,CACrB,AACD,uFAEE,WAAY,AACZ,eAAgB,AAChB,kBAAoB,CACrB,AACD,2CACE,eAAiB,CAClB,AACD,4CACE,eAAiB,CAClB,AACD,qBACE,qBAAsB,AACtB,mBAAoB,AACpB,WAAa,CACd,AACD,4CACE,mBAAoB,AACpB,kBAAoB,AACpB,gBAAkB,CACnB,AACD,sCACE,iBAAmB,AACnB,mBAAqB,CACtB,AACD,gFAEE,kBAAoB,CACrB,AACD,oEAEE,mBAAqB,CACtB,AACD,iBACE,6EAA8E,AAC9E,wBAA0B,CAC3B,AACD,wBACE,oCAAuC,CACxC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,qEAAuE,CACxE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,8DAAgE,CACjE,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,uDAAyD,CAC1D,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,gDAAkD,CACnD,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,yCAA2C,CAC5C,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,6BACE,kCAAoC,CACrC,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,2BAA6B,CAC9B,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,wCAA2C,CAC5C,AACD,6BACE,oBAAsB,CACvB,AACD,6BACE,wBAA0B,CAC3B,AACD,oCACE,oCAAuC,CACxC,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,kBAAoB,CACrB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,mBAAqB,CACtB,AACD,+CACE,gBAAkB,CACnB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,iBAAmB,CACpB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,+CACE,iBAAmB,CACpB,AACD,iDACE,mBAAqB,CACtB,AACD,wDACE,kBAAoB,CACrB,AACD,0DACE,oBAAsB,CACvB,AACD,qBACE,cAAe,AACf,cAAgB,CACjB,AACD,qCACE,aAAe,CAChB,AACD,oCACE,iBAAmB,CACpB,AACD,wBACE,qBAAuB,CACxB,AACD,sBACE,wBAA0B,CAC3B,AACD,yBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,wBACE,wBAA0B,CAC3B,AACD,uBACE,qBAAuB,CACxB,AACD,yBACE,qBAAuB,CACxB,AACD,2BACE,UAAY,CACb,AACD,yBACE,aAAe,CAChB,AACD,4BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,2BACE,aAAe,CAChB,AACD,0BACE,UAAY,CACb,AACD,4BACE,UAAY,CACb,AACD,0BACE,yCAA6C,CAC9C,AACD,8BACE,wCAA4C,CAC7C,AACD,0BACE,eAAkB,CACnB,AACD,0BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,6BACE,cAAe,AACf,kBAAoB,CACrB,AACD,4BACE,iBAAmB,CACpB,AACD,6BACE,kBAAoB,CACrB,AACD,2BACE,gBAAkB,CACnB,AACD,2BACE,qBAAuB,AACvB,+BAAgC,AAChC,kBAAmB,AACnB,UAAW,AACX,oBAAqB,AACrB,kBAAmB,AACnB,UAAY,CACb,AACD,MACE,cAAe,AACf,eAAgB,AAChB,oBAAsB,CACvB,AACD,cACE,yBAA2B,AAC3B,gBAAiB,AACjB,2BAA6B,AAC7B,+BAAkC,CACnC","file":"CondicoesDeUso.vue","sourcesContent":["\n.ql-container {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  font-family: Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  height: 100%;\n  margin: 0px;\n  position: relative;\n}\n.ql-container.ql-disabled .ql-tooltip {\n  visibility: hidden;\n}\n.ql-container.ql-disabled .ql-editor ul[data-checked] > li::before {\n  pointer-events: none;\n}\n.ql-clipboard {\n  left: -100000px;\n  height: 1px;\n  overflow-y: hidden;\n  position: absolute;\n  top: 50%;\n}\n.ql-clipboard p {\n  margin: 0;\n  padding: 0;\n}\n.ql-editor {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  line-height: 1.42;\n  height: 100%;\n  outline: none;\n  overflow-y: auto;\n  padding: 12px 15px;\n  -o-tab-size: 4;\n     tab-size: 4;\n  -moz-tab-size: 4;\n  text-align: left;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n.ql-editor > * {\n  cursor: text;\n}\n.ql-editor p,\n.ql-editor ol,\n.ql-editor ul,\n.ql-editor pre,\n.ql-editor blockquote,\n.ql-editor h1,\n.ql-editor h2,\n.ql-editor h3,\n.ql-editor h4,\n.ql-editor h5,\n.ql-editor h6 {\n  margin: 0;\n  padding: 0;\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n}\n.ql-editor ol > li,\n.ql-editor ul > li {\n  list-style-type: none;\n}\n.ql-editor ul > li::before {\n  content: '\\2022';\n}\n.ql-editor ul[data-checked=true],\n.ql-editor ul[data-checked=false] {\n  pointer-events: none;\n}\n.ql-editor ul[data-checked=true] > li *,\n.ql-editor ul[data-checked=false] > li * {\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before,\n.ql-editor ul[data-checked=false] > li::before {\n  color: #777;\n  cursor: pointer;\n  pointer-events: all;\n}\n.ql-editor ul[data-checked=true] > li::before {\n  content: '\\2611';\n}\n.ql-editor ul[data-checked=false] > li::before {\n  content: '\\2610';\n}\n.ql-editor li::before {\n  display: inline-block;\n  white-space: nowrap;\n  width: 1.2em;\n}\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n.ql-editor li.ql-direction-rtl::before {\n  margin-left: 0.3em;\n  margin-right: -1.5em;\n}\n.ql-editor ol li:not(.ql-direction-rtl),\n.ql-editor ul li:not(.ql-direction-rtl) {\n  padding-left: 1.5em;\n}\n.ql-editor ol li.ql-direction-rtl,\n.ql-editor ul li.ql-direction-rtl {\n  padding-right: 1.5em;\n}\n.ql-editor ol li {\n  counter-reset: list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n  counter-increment: list-0;\n}\n.ql-editor ol li:before {\n  content: counter(list-0, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-increment: list-1;\n}\n.ql-editor ol li.ql-indent-1:before {\n  content: counter(list-1, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-1 {\n  counter-reset: list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-increment: list-2;\n}\n.ql-editor ol li.ql-indent-2:before {\n  content: counter(list-2, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-2 {\n  counter-reset: list-3 list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-increment: list-3;\n}\n.ql-editor ol li.ql-indent-3:before {\n  content: counter(list-3, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-3 {\n  counter-reset: list-4 list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-increment: list-4;\n}\n.ql-editor ol li.ql-indent-4:before {\n  content: counter(list-4, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-4 {\n  counter-reset: list-5 list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-increment: list-5;\n}\n.ql-editor ol li.ql-indent-5:before {\n  content: counter(list-5, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-5 {\n  counter-reset: list-6 list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-increment: list-6;\n}\n.ql-editor ol li.ql-indent-6:before {\n  content: counter(list-6, decimal) '. ';\n}\n.ql-editor ol li.ql-indent-6 {\n  counter-reset: list-7 list-8 list-9;\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-increment: list-7;\n}\n.ql-editor ol li.ql-indent-7:before {\n  content: counter(list-7, lower-alpha) '. ';\n}\n.ql-editor ol li.ql-indent-7 {\n  counter-reset: list-8 list-9;\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-increment: list-8;\n}\n.ql-editor ol li.ql-indent-8:before {\n  content: counter(list-8, lower-roman) '. ';\n}\n.ql-editor ol li.ql-indent-8 {\n  counter-reset: list-9;\n}\n.ql-editor ol li.ql-indent-9 {\n  counter-increment: list-9;\n}\n.ql-editor ol li.ql-indent-9:before {\n  content: counter(list-9, decimal) '. ';\n}\n.ql-editor .ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 3em;\n}\n.ql-editor li.ql-indent-1:not(.ql-direction-rtl) {\n  padding-left: 4.5em;\n}\n.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 3em;\n}\n.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right {\n  padding-right: 4.5em;\n}\n.ql-editor .ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 6em;\n}\n.ql-editor li.ql-indent-2:not(.ql-direction-rtl) {\n  padding-left: 7.5em;\n}\n.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 6em;\n}\n.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right {\n  padding-right: 7.5em;\n}\n.ql-editor .ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 9em;\n}\n.ql-editor li.ql-indent-3:not(.ql-direction-rtl) {\n  padding-left: 10.5em;\n}\n.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 9em;\n}\n.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right {\n  padding-right: 10.5em;\n}\n.ql-editor .ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 12em;\n}\n.ql-editor li.ql-indent-4:not(.ql-direction-rtl) {\n  padding-left: 13.5em;\n}\n.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 12em;\n}\n.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right {\n  padding-right: 13.5em;\n}\n.ql-editor .ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 15em;\n}\n.ql-editor li.ql-indent-5:not(.ql-direction-rtl) {\n  padding-left: 16.5em;\n}\n.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 15em;\n}\n.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right {\n  padding-right: 16.5em;\n}\n.ql-editor .ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 18em;\n}\n.ql-editor li.ql-indent-6:not(.ql-direction-rtl) {\n  padding-left: 19.5em;\n}\n.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 18em;\n}\n.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right {\n  padding-right: 19.5em;\n}\n.ql-editor .ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 21em;\n}\n.ql-editor li.ql-indent-7:not(.ql-direction-rtl) {\n  padding-left: 22.5em;\n}\n.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 21em;\n}\n.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right {\n  padding-right: 22.5em;\n}\n.ql-editor .ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 24em;\n}\n.ql-editor li.ql-indent-8:not(.ql-direction-rtl) {\n  padding-left: 25.5em;\n}\n.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 24em;\n}\n.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right {\n  padding-right: 25.5em;\n}\n.ql-editor .ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 27em;\n}\n.ql-editor li.ql-indent-9:not(.ql-direction-rtl) {\n  padding-left: 28.5em;\n}\n.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 27em;\n}\n.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right {\n  padding-right: 28.5em;\n}\n.ql-editor .ql-video {\n  display: block;\n  max-width: 100%;\n}\n.ql-editor .ql-video.ql-align-center {\n  margin: 0 auto;\n}\n.ql-editor .ql-video.ql-align-right {\n  margin: 0 0 0 auto;\n}\n.ql-editor .ql-bg-black {\n  background-color: #000;\n}\n.ql-editor .ql-bg-red {\n  background-color: #e60000;\n}\n.ql-editor .ql-bg-orange {\n  background-color: #f90;\n}\n.ql-editor .ql-bg-yellow {\n  background-color: #ff0;\n}\n.ql-editor .ql-bg-green {\n  background-color: #008a00;\n}\n.ql-editor .ql-bg-blue {\n  background-color: #06c;\n}\n.ql-editor .ql-bg-purple {\n  background-color: #93f;\n}\n.ql-editor .ql-color-white {\n  color: #fff;\n}\n.ql-editor .ql-color-red {\n  color: #e60000;\n}\n.ql-editor .ql-color-orange {\n  color: #f90;\n}\n.ql-editor .ql-color-yellow {\n  color: #ff0;\n}\n.ql-editor .ql-color-green {\n  color: #008a00;\n}\n.ql-editor .ql-color-blue {\n  color: #06c;\n}\n.ql-editor .ql-color-purple {\n  color: #93f;\n}\n.ql-editor .ql-font-serif {\n  font-family: Georgia, Times New Roman, serif;\n}\n.ql-editor .ql-font-monospace {\n  font-family: Monaco, Courier New, monospace;\n}\n.ql-editor .ql-size-small {\n  font-size: 0.75em;\n}\n.ql-editor .ql-size-large {\n  font-size: 1.5em;\n}\n.ql-editor .ql-size-huge {\n  font-size: 2.5em;\n}\n.ql-editor .ql-direction-rtl {\n  direction: rtl;\n  text-align: inherit;\n}\n.ql-editor .ql-align-center {\n  text-align: center;\n}\n.ql-editor .ql-align-justify {\n  text-align: justify;\n}\n.ql-editor .ql-align-right {\n  text-align: right;\n}\n.ql-editor.ql-blank::before {\n  color: rgba(0,0,0,0.6);\n  content: attr(data-placeholder);\n  font-style: italic;\n  left: 15px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n}\n.link{\n  color: #1470c8;\n  cursor: pointer;\n  text-decoration: none;\n}\n.modal-header{\n  font-size: 22px !important;\n  font-weight: 400;\n  line-height: 32px !important;\n  letter-spacing: normal !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(612);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("5001cbe3", content, true, {});

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(635);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(361)("18428244", content, true, {});

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(50)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(767),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 739:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkout"
  }, [_c('v-dialog', {
    attrs: {
      "scrollable": "",
      "max-width": "300"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("Precauções")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        É necessário desocupar o local no intervalo de tempo entre seis e oito horas. - Aguardar rigorosamente o tempo definido."), _c('br'), _c('br'), _vm._v("\n        Crianças, pessoas idosas ou alérgicas, deverão observar um prazo específico, ou solicitar orientação médica."), _c('br'), _vm._v("\n        - Evite lavar os locais nos 03 primeiros dias após a aplicação, bem como usar produtos à base de pinho, que podem neutralizar a ação dos inseticidas."), _c('br'), _c('br'), _vm._v("\n        É possível o surgimento de insetos nos primeiros dias após a aplicação (o inseticida possui ação desalojante). Aguarde de 15 a 20 dias para a avaliação dos serviços."), _c('br'), _c('br'), _vm._v("\n        - Insetos em geral têm hábitos noturnos; evite deixar restos de alimentos acessíveis a eles durante a noite."), _c('br'), _vm._v("\n        - Em caso de nova infestação, durante o período de garantia, basta telefonar e agendar aplicação de reforço, sem qualquer custo adicional.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-checkbox', {
    attrs: {
      "color": "green"
    },
    model: {
      value: (_vm.aware),
      callback: function($$v) {
        _vm.aware = $$v
      },
      expression: "aware"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("Estou ciente")])])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "loading": _vm.loadingOrderRequest,
      "disabled": !_vm.loadingOrderRequest && !_vm.aware,
      "flat": "flat"
    },
    on: {
      "click": _vm.requestOrder
    },
    nativeOn: {
      "click": function($event) {
        _vm.loader = 'loading'
      }
    }
  }, [_vm._v("\n           confirmar pedido\n         ")]), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1), _vm._v(" "), _c('v-slide-x-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(_vm.client !== null) ? _c('div', {
    staticClass: "box-want"
  }, [_c('div', {
    staticClass: "description"
  }, [_c('strong', [_vm._v("  " + _vm._s(_vm.client.name) + " ")]), _vm._v(", \n      seu condomínio passará por "), _c('strong', [_vm._v(" \n      " + _vm._s(_vm.client.category) + " ")]), _vm._v(" pela empresa "), _c('strong', [_vm._v(" " + _vm._s(_vm.client.business) + " ")]), _vm._v(", conforme agendamento abaixo.\n    ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date pt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('strong', [_c('v-icon', [_vm._v("event")]), _vm._v(" Data:\n      ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [(_vm.item.dates.length > 0) ? _c('v-select', {
    staticClass: "pt-0 hour-select",
    attrs: {
      "items": _vm.item.dates,
      "hide-details": "",
      "single-line": "",
      "prepend": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "date"
        }, [_vm._v(_vm._s(_vm._f("formatDate")(data.item)))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('div', {
          key: JSON.stringify(data.formatDate)
        }, [_vm._v("\n          " + _vm._s(_vm._f("formatDate")(data.item)) + "\n        ")])]
      }
    }], null, false, 831896227),
    model: {
      value: (_vm.dateChoosen),
      callback: function($$v) {
        _vm.dateChoosen = $$v
      },
      expression: "dateChoosen"
    }
  }) : _c('div', {}, [_vm._v("\n        " + _vm._s(_vm._f("formatDate")(_vm.item.dateSchedule)) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date pt-0",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('strong', [_c('v-icon', [_vm._v("business")]), _vm._v(" Unidade:\n      ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [(_vm.unity.length !== 1) ? _c('v-select', {
    staticClass: "pt-0 hour-select",
    attrs: {
      "items": _vm.client.unity,
      "hide-details": "",
      "single-line": "",
      "prepend": "",
      "append-icon": "",
      "bottom": ""
    },
    model: {
      value: (_vm.unityChoosen),
      callback: function($$v) {
        _vm.unityChoosen = $$v
      },
      expression: "unityChoosen"
    }
  }) : _c('div', {}, [_vm._v("\n        " + _vm._s(_vm.client.unity[0]) + "\n      ")])], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "mt-2": ""
    }
  }, [_c('hr')])], 1), _vm._v(" "), _c('div', {
    staticClass: "more-description"
  }, [_vm._v("\n    Esse é o momento ideal para agendar o serviço.\n  ")]), _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date mt-2 mb-2 pa-0",
    attrs: {
      "slot": "activator",
      "row": "",
      "wrap": ""
    },
    slot: "activator"
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    staticStyle: {
      "word-break": "break-all"
    }
  }, [_c('v-select', {
    staticClass: "pt-0",
    attrs: {
      "items": _vm.item.priceTable,
      "item-text": "description",
      "item-value": "provider",
      "hide-details": "",
      "single-line": "",
      "bottom": ""
    },
    model: {
      value: (_vm.itemChoosen),
      callback: function($$v) {
        _vm.itemChoosen = $$v
      },
      expression: "itemChoosen"
    }
  })], 1)], 1), _vm._v(" "), (_vm.price !== _vm.priceRef) ? [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "real-price"
  }, [_c('div', {}, [_vm._v("\n          De " + _vm._s(_vm._f("currency")(_vm.priceRef)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "discount-price"
  }, [_c('span', [_vm._v("Por ")]), _vm._v(" " + _vm._s(_vm._f("currency")(_vm.price)) + "\n      ")])])] : [_c('div', {
    staticClass: "price"
  }, [_c('div', {
    staticClass: "discount-price"
  }, [_vm._v("\n        " + _vm._s(_vm._f("currency")(_vm.price)) + "\n      ")])])], _vm._v(" "), _c('v-layout', {
    staticClass: "realization-date mt-3 pa-0 mb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('strong', [_c('v-icon', [_vm._v("access_time")]), _vm._v(" Escolha um horário:\n      ")], 1)]), _vm._v(" "), _c('v-flex', [_c('v-select', {
    staticClass: "pt-0 hour-select",
    attrs: {
      "items": _vm.avaliableSchedule,
      "hide-details": "",
      "single-line": "",
      "prepend": "",
      "append-icon": "",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('span', {
          staticClass: "time"
        }, [_vm._v(_vm._s(_vm._f("time")(data.item)))])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [_c('div', {
          key: JSON.stringify(data.item)
        }, [_vm._v("\n            " + _vm._s(_vm._f("time")(data.item)) + "\n          ")])]
      }
    }], null, false, 1656706560),
    model: {
      value: (_vm.timeChoosen),
      callback: function($$v) {
        _vm.timeChoosen = $$v
      },
      expression: "timeChoosen"
    }
  })], 1)], 1), _vm._v(" "), (_vm.paymentsViewModel.length > 0) ? [_c('v-layout', {
    staticClass: "realization-date pa-0 mb-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left"
  }, [_c('strong', [_c('v-icon', [_vm._v("payment")]), _vm._v(" Pagamento:\n        ")], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    staticClass: "text-xs-center",
    attrs: {
      "items": _vm.paymentsViewModel,
      "hide-details": "",
      "item-text": "description",
      "item-value": "id",
      "single-line": "",
      "prepend": "",
      "bottom": ""
    },
    model: {
      value: (_vm.paymentChoosen),
      callback: function($$v) {
        _vm.paymentChoosen = $$v
      },
      expression: "paymentChoosen"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mb-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center alert--text"
  }, [_vm._v("\n        Pagamento realizado na visita\n      ")])], 1)] : _vm._e(), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "color": "green",
      "hide-details": "",
      "light": ""
    },
    model: {
      value: (_vm.acceptance),
      callback: function($$v) {
        _vm.acceptance = $$v
      },
      expression: "acceptance"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("li e aceito: "), _c('CondicoesDeUso')], 1)]), _vm._v(" "), (_vm.itemActive) ? _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "block": ""
    },
    on: {
      "click": _vm.openDialog
    }
  }, [_vm._v("\n    Confirmar pedido\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)]) : _c('v-btn', {
    staticClass: "btn-hotsite",
    attrs: {
      "large": "",
      "disabled": true,
      "block": ""
    }
  }, [_vm._v("\n    Oferta expirada\n    "), _c('span', {
    staticClass: "custom-loader",
    attrs: {
      "slot": "loader"
    },
    slot: "loader"
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("cached")])], 1)])], 2) : _vm._e()]), _vm._v(" "), _c('v-slide-y-reverse-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [(!_vm.loadingCheckout) ? _c('Feedback', {
    staticClass: "feedback-btn",
    attrs: {
      "token": _vm.token
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 767:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "scrollable": ""
    },
    model: {
      value: (_vm.condicoesDeUso),
      callback: function($$v) {
        _vm.condicoesDeUso = $$v
      },
      expression: "condicoesDeUso"
    }
  }, [_c('span', {
    staticClass: "link",
    staticStyle: {
      "text-align": "center !important"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Condições de uso")]), _vm._v(" "), _c('v-card', [_c('v-card-title', {
    staticStyle: {
      "display": "inline",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "modal-header",
    staticStyle: {
      "text-align": "center !important"
    }
  }, [_vm._v("Condições de uso")])]), _vm._v(" "), _c('v-card-text', {
    staticClass: "ql-editor"
  }, [_c('p', {
    staticClass: "ql-align-center"
  }, [_c('strong', [_vm._v("TERMO DE USO: Condoplaza")])]), _vm._v(" "), _c('p', [_vm._v("A Administradora não se responsabiliza pelas negociações e transações originadas através deste site.")]), _vm._v(" "), _c('p', {
    staticClass: "ql-align-center"
  }, [_c('strong', [_vm._v("TERMO DE USO: Fornecedor")])]), _vm._v(" "), _c('p', {
    staticClass: "ql-align-justify"
  }, [_vm._v("\n        Nós, da Desentupidora, forneceremos todos os materiais e mão-de-obra necessária à completa execução dos serviços de dedetização,correndo por sua conta e risco a organização dos trabalhos conforme se segue:\n      ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Combate químico nas áreas das unidades, utilizando os métodos mais adequados a cada caso: spray, gel, granulado, iscas, blocos parafinados, pó de contato, atomização, etc.;")]), _vm._v(" "), _c('li', [_vm._v("Neste serviço estão incluídos os vetores e pragas urbanas a seguir: Baratas – pulgas - formigas – escorpiões – traças – lacraias – moscas - mosquitos – roedores – carrapatos – lesmas – lagartas.")]), _vm._v(" "), _c('li', [_vm._v("Não está incluso o combate a: Morcegos, Pombos e Cupins, bem como os serviços e matérias necessários para barreiras físicas, tais como: Telas, Redes, Alvenaria, etc.")]), _vm._v(" "), _c('li', [_vm._v("Os métodos utilizados, conforme a necessidade de cada local consiste em:\n          "), _c('ul', [_c('li', [_c('strong', [_vm._v("SPRAY")]), _vm._v(" – pulverização com equipamento manual de inseticidas piretróides sintéticos e/ou organofosforados para combate a pulgas, carrapatos, escorpiões e algumas outras espécies de insetos.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("GEL")]), _vm._v(" – aplicação com pistolas manuais de gel para combate às baratas e/ ou formigas.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("GRANULADO")]), _vm._v(" – aplicação de formicida à base de Sulfluramid de forma granulada, para combate às formigas.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("ISCAS – BLOCOS PARAFINADOS – PÓS DE CONTATO")]), _vm._v(" – raticidas de dose única e ação anticoagulante, à base de benzotiopirona, walfarina, cumarinas ou hidroxicumarina, para combate a roedores em geral.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("ATOMIZAÇÃO")]), _vm._v(" – atomização com equipamento elétrico, em áreas fechadas, para controle de insetos voadores.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("NEBULIZAÇÃO")]), _vm._v(" - equipamento à base de gasolina, usado em áreas fechadas, para controle de insetos voadores.")]), _vm._v(" "), _c('li', [_c('strong', [_vm._v("POLVILHAMENTO")]), _vm._v(" – aplicação de pó inseticida, em locais onde o uso do inseticida liquido não é aconselhável.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "ql-align-justify"
  }, [_vm._v("A Desentupidora declara ter estrutura adequada para atender aos serviços solicitados, como:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Executar os serviços dentro dos melhores padrões de qualidade, utilizando-se da mais moderna tecnologia, empregando material de primeira qualidade.")]), _vm._v(" "), _c('li', [_vm._v("Utilizar para a presente prestação de serviço, equipamentos de sua propriedade, ficando ao nosso critério os tipos, adequação e quantidade destes equipamentos;")]), _vm._v(" "), _c('li', [_vm._v("Operar com empregados devidamente treinados e preparados para execução das atividades solicitadas, em número suficiente à perfeita prestação de serviços;")]), _vm._v(" "), _c('li', [_vm._v("Fornecer aos empregados e demais trabalhadores por ela contratados equipamentos individuais de segurança, exercendo a respectiva fiscalização.")])]), _vm._v(" "), _c('p', {
    staticClass: "ql-align-center"
  }, [_c('strong', [_vm._v("IMPORTANTE:")])]), _vm._v(" "), _c('p', {
    staticClass: "ql-align-justify"
  }, [_c('strong', [_vm._v("É de suma importância que o cliente (morador da unidade), esteja ciente das precauções para que o serviço de dedetização seja realizado com sucesso.")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.condicoesDeUso = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.e44e5690955cc2afd0a6.js